import { all, fork, takeEvery, takeLatest, select, call, put } from 'redux-saga/effects';
import { notification } from 'antd';

import actions from './actions';
import API_ENDPOINT from '../../settings';
import { makeSelectPageToken } from '../socialPage/selector';
import request from '../../helpers/request';

/* eslint func-names: ["error", "never"] */
/* eslint-disable no-return-await */

export function* loadGifts() {
  yield takeLatest(actions.LOAD_GIFT, function*(action) {
    // const pageToken = yield select(makeSelectPageToken());

    const limit = action.limit ? action.limit : 50;
    const skip = action.skip ? action.skip : 0;
    // console.log('pageToken', pageToken);
    const url = `${API_ENDPOINT.apiUrl}/gifts?pageId=${action.pageId}&limit=${limit}&skip=${skip}`;

    try {
      const result = yield call(
        request,
        url,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            // Authorization: `Bearer ${pageToken}`,
          },
        }
      );
      // console.log('loaded tasks', result);
      yield put(actions.loadGiftSuccess(result, skip > 0));
    } catch (error) {
      console.log('load gift error', error.message);
      yield put({
        type: actions.LOAD_GIFT_ERROR,
        error: error.message,
      });
    }
  });
}

export function* createGift() {
  yield takeLatest(actions.CREATE_GIFT, function*(action) {
    const pageToken = yield select(makeSelectPageToken());
    try {
      const result = yield call(request, `${API_ENDPOINT.apiUrl}/gifts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${pageToken}`,
        },
        body: JSON.stringify(action.data)
      });
      // console.log('created campaign', result);
      yield put(actions.createGiftSuccess(result));
    } catch (err) {
      console.log('create gift error', err);
      yield put(actions.createGiftError(err.message));
    }
  });
}

export function* deleteGift() {
  yield takeEvery(actions.DELETE_GIFT, function*(action) {
    const pageToken = yield select(makeSelectPageToken());

    const url = `${API_ENDPOINT.apiUrl}/gifts/${action.id}`;

    try {
      const result = yield call(
        request,
        url,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${pageToken}`,
          },
        }
      );
      // console.log('deleted task', result);
      yield put(actions.deleteGiftSuccess(result._id));
      notification.success({ message: 'Deleted' })
    } catch (error) {
      console.log('delete gift error', error.message);
      yield put({
        type: actions.DELETE_GIFT_ERROR,
        error: error.message,
      });
      notification.error({ message: error.message });
    }
  });
}

export function* updateGift() {
  yield takeEvery(actions.UPDATE_GIFT, function*(action) {
    const pageToken = yield select(makeSelectPageToken());
    const url = `${API_ENDPOINT.apiUrl}/gifts/${action.id}`;

    try {
      const result = yield call(
        request,
        url,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${pageToken}`,
          },
          body: JSON.stringify(action.data),
        }
      );
      // console.log('deleted leads', result);
      yield put(actions.updateGiftSuccess(result));
      notification.success({ message: 'Updated' })
    } catch (error) {
      console.log('update gift error', error);
      yield put({
        type: actions.UPDATE_GIFT_ERROR,
        error: error.message,
      });
      notification.error({ message: error.message });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(loadGifts),
    fork(createGift),
    fork(deleteGift),
    fork(updateGift),
  ]);
}
